export const REACT_APP_MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY || 'YOUR_API_KEY';